import React, { memo, useMemo } from "react";
import { singleAccordion } from "../CommonForm/CommonFormInterface";
import Summary from "../Summary/Summary";

const SingleAccordion = ({
  field,
  isAccordionOpen,
  extractedSingleAccordionLabel,
  onClickSingleAccordionSummary,
  children,
}: {
  field: singleAccordion;
  isAccordionOpen: boolean;
  extractedSingleAccordionLabel: string;
  onClickSingleAccordionSummary: (e: any) => void;
  children: React.ReactNode;
}) => {
  const extractedSingleAccordionSrc = useMemo(
    () =>
      `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}${
        field?.imageUrl ?? "/icons/down-arrow.svg"
      }`,
    [field?.imageUrl]
  );
  return (
    <Summary
      id={`${field?.fieldKey ?? ""}`}
      isSummaryOpen={isAccordionOpen}
      detailStyles={field?.detailStyles}
      summaryStyles={field?.summaryStyles}
      className={field?.className ?? ""}
      labelType={field?.labelType}
      labelStyle={field?.tagStyle}
      onClose={onClickSingleAccordionSummary}
      label={field?.dynamicLabel ? extractedSingleAccordionLabel : field?.label}
      closeImageConfig={{
        src: extractedSingleAccordionSrc,
        alt: field?.imageAlt,
        imageHeight: field.imageHeight,
        imageWidth: field.imageWidth,
        className: field?.imageClassName ?? "",
      }}
    >
      {children}
    </Summary>
  );
};

export default memo(SingleAccordion);
